import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'
import { toAssistantSurfaceId } from 'tripPlanner/assistant/surfaceSnapshots/assistantSurfacePlainText'

// offerId in `fields`, not embedded in displayText -- gives the model a live pointer back to
// lookup_offer for a drawer opened earlier in the turn (e.g. "which was cheapest?" after
// comparing several), not just the name it was opened under.
//
// Normalized through toAssistantSurfaceId, not passed raw -- offerId originates from
// assistant-authored markdown link targets (markdownUtils.tsx's hotel:/experience:/cruise: link
// handling), unvalidated. svc-trip rejects a field value containing a URL scheme or markdown/HTML,
// and a failing value is silently dropped from the whole entry rather than surfaced as an error --
// so an LLM-authored id that happens to look like `hotel:https://maps.app.goo.gl/xyz` would
// otherwise lose this field with nothing to catch it. toAssistantSurfaceId's safe charset can't
// contain '://' (it isn't in the allowed charset), so a normalized value can never trip that
// rejection; the field is omitted entirely (not sent empty) if normalization leaves nothing.
export function buildOfferDrawerOpenedActivityEntry(name: string, offerType: string, offerId: string): TripPlannerSurfaceActivityEntry {
  const normalizedOfferId = toAssistantSurfaceId(offerId)
  return {
    kind: 'offer_drawer_opened',
    label: 'Opened offer details',
    displayText: boundActivityDisplayText(`Opened ${offerType} "${name}"`),
    sourcePath: 'trip_planner.drawer.offer',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
    ...(normalizedOfferId !== undefined ? { fields: [{ key: 'offerId', value: normalizedOfferId, dataClassification: 'commercial_surface' as const }] } : {}),
  }
}
